



















































import BaseTooltipIconButton from "@/components/shared/button/BaseTooltipIconButton.vue";
import BaseTableFiltered from "@/components/shared/table/BaseTableFiltered.vue";
import { defineComponent } from "@vue/composition-api";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "SubjectTable",
  components: {
    BaseTooltipIconButton,
    BaseTableFiltered,
  },
  props: {
    expanded: Object,
    canUpsert: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ search: "" }),
  computed: {
    ...mapGetters("subjectRegister", ["getSubjectRegister"]),
    ...mapGetters("plans", ["getDefaultOpt"]),
    hadToBeHere(): any {
      return [this.expanded];
    },
    subHeaders() {
      return [
        { text: "Internkode", value: "id" },
        { text: "Kursområde", value: "description" },
        { text: "SSB kode", value: "ssbCode" },
        { text: "Status", value: "isActive" },
        { text: "Handlinger", value: "actions" },
      ];
    },
    mainHeaders() {
      return [
        { text: "", value: "actions" },
        { text: "Internkode", value: "code" },
        { text: "Hovedområde", value: "description" },
        { text: "Status", value: "isActive" },
      ];
    },
  },
  methods: {
    ...mapActions("subjectRegister", ["fetchSubjectRegister"]),
    ...mapActions("plans", ["fetchDefaultOptions"]),
    newSubject() {
      this.$store.commit("subjectRegister/SET_SUBJECT", {});

      const modal = {
        type: "add",
        headline: "Nytt emne",
      };
      this.$store.commit("hoc/SET_MODAL_TYPE", modal);
      this.$store.commit("hoc/OPEN_MODAL", "SubjectRegister");
    },
  },
  async mounted() {
    await (this as any).fetchSubjectRegister();
    await (this as any).fetchDefaultOptions();
  },
});
